import { render, staticRenderFns } from "./UpdateRequireInfo.vue?vue&type=template&id=dcb5d8c6&"
import script from "./UpdateRequireInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateRequireInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb5d8c6')) {
      api.createRecord('dcb5d8c6', component.options)
    } else {
      api.reload('dcb5d8c6', component.options)
    }
    module.hot.accept("./UpdateRequireInfo.vue?vue&type=template&id=dcb5d8c6&", function () {
      api.rerender('dcb5d8c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/UpdateRequireInfo.vue"
export default component.exports